/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { ApiUserTasksGetLastSelectedIdParameter } from './ApiUserTasksGetLastSelectedIdParameter';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterFromJSONTyped,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSONTyped,
} from './ApiUserTasksGetLastSelectedIdParameter';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface EnrollmentWarning
 */
export interface EnrollmentWarning {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof EnrollmentWarning
     */
    classId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof EnrollmentWarning
     */
    studentId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {ApiUserTasksGetLastSelectedIdParameter}
     * @memberof EnrollmentWarning
     */
    enrollmentId: ApiUserTasksGetLastSelectedIdParameter;
    /**
     * 
     * @type {Error}
     * @memberof EnrollmentWarning
     */
    warning: Error;
}

/**
 * Check if a given object implements the EnrollmentWarning interface.
 */
export function instanceOfEnrollmentWarning(value: object): value is EnrollmentWarning {
    if (!('classId' in value) || value['classId'] === undefined) return false;
    if (!('studentId' in value) || value['studentId'] === undefined) return false;
    if (!('enrollmentId' in value) || value['enrollmentId'] === undefined) return false;
    if (!('warning' in value) || value['warning'] === undefined) return false;
    return true;
}

export function EnrollmentWarningFromJSON(json: any): EnrollmentWarning {
    return EnrollmentWarningFromJSONTyped(json, false);
}

export function EnrollmentWarningFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnrollmentWarning {
    if (json == null) {
        return json;
    }
    return {
        
        'classId': ApiUserTasksGetPageParameterFromJSON(json['classId']),
        'studentId': ActorActivityRecordActorUserIdFromJSON(json['studentId']),
        'enrollmentId': ApiUserTasksGetLastSelectedIdParameterFromJSON(json['enrollmentId']),
        'warning': json['warning'],
    };
}

export function EnrollmentWarningToJSON(json: any): EnrollmentWarning {
    return EnrollmentWarningToJSONTyped(json, false);
}

export function EnrollmentWarningToJSONTyped(value?: EnrollmentWarning | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'classId': ApiUserTasksGetPageParameterToJSON(value['classId']),
        'studentId': ActorActivityRecordActorUserIdToJSON(value['studentId']),
        'enrollmentId': ApiUserTasksGetLastSelectedIdParameterToJSON(value['enrollmentId']),
        'warning': value['warning'],
    };
}

